import React from "react";

export const AppointmentsContext = React.createContext({
  appointments: []
});
